import axios from 'axios'
import FormErrors from "./FormErrors";

class ContactForm {
    constructor( el ) {
        this.el = el;
        this.inputs = {};
        this.action = el.querySelector('form').action
        this.fields = this.el.querySelectorAll('input, textarea');
        this.fields.forEach( el => {
            this.inputs[el.id] = '';
            if( el.type === 'text' || el.type === 'textarea' ) {
                el.addEventListener('input', this.handleInput.bind(this));
            } else {
                el.addEventListener('change', this.handleInput.bind(this));
            }
        } );

        this.errors = new FormErrors( this.fields );

        this.el.querySelector('.submit-button').addEventListener('click', this.send.bind(this))
    }

    handleInput( ev ) {
        if( ev.type === 'input' ) {
            this.inputs[ev.target.id] = ev.target.value;
        } else {
            this.inputs[ev.target.id] = ev.target.checked;
        }
    }

    send( ev ) {
        ev.preventDefault();
        this.el.querySelector('form').style.display = 'none';
        this.el.querySelector('.response-container.loading').style.display = 'block';
        let data = new FormData();

        this.fields.forEach( (el) => {
            if( el.type !== 'file' ) {
                data.append(el.id, this.inputs[el.id] );
            } else {
                data.append( el.id, el.files[0] );
            }
        });

        axios.post( this.action, data )
            .then( response => {
                this.el.querySelector('.response-container.loading').style.display = 'none';
                this.el.querySelector('.response-container.success').style.display = 'block';
            })
            .catch( errors => {
                this.el.querySelector('.response-container.loading').style.display = 'none';
                if( errors.response.status === 422 ) {
                    this.errors.record( errors.response.data.errors );
                    this.el.querySelector('form').style.display = 'block';
                } else {
                    this.el.querySelector('.response-container.error').style.display = 'block';
                }
            })
    }
}

export default ContactForm;